import * as THREE from 'three';
import { getGroupOrderZ } from '@/utils/enumHelper';
import { create_routing_stop, getStopTexture } from '../js/vehicleHelper';
import { disposeO3D } from '../js/threejsHelper';

let group_vehicleRouting = null; //主车导航的图层
let visible_group = true;
let routing_stop = {
  mainStop: null,
  parking_spot: null,
  visible: true,
  id: null,
}; //routing的停靠点，固定的只需要渲染一次；分为主停靠和备用停靠点
// 对齐地图虚线 dashSize 1 + gapSize 0.5；主副同周期，起点错开半周期。
const ROUTING_DASH_SIZE = 1;
const ROUTING_GAP_SIZE = 0.8;
const ROUTING_ARROW_SPACING = ROUTING_DASH_SIZE + ROUTING_GAP_SIZE;
const ROUTING_ARROW_START_MAIN = ROUTING_ARROW_SPACING * 0.5;
const ROUTING_ARROW_START_SUB = 0;
const ROUTING_ARROW_SCALE_MAIN = 0.9;
const ROUTING_ARROW_SCALE_SUB = 0.7;
const ROUTING_SUB_LATERAL_OFFSET = 0;
const routingArrowDummy = new THREE.Object3D();
const routingMaterialOpts = {
  side: THREE.DoubleSide,
  transparent: true,
  depthWrite: false,
  depthTest: false,
};
let vehicleRouting_material = new THREE.MeshBasicMaterial({
  ...routingMaterialOpts,
  color: 0x00ffcc,
  opacity: 1,
});
let vehicleRouting_material_sub = new THREE.MeshBasicMaterial({
  ...routingMaterialOpts,
  color: 0xcc55ff,
  opacity: 1,
});

// let vehicleRouting_material_motor_main = new THREE.MeshBasicMaterial({
//   color: 0x401c44,
//   side: THREE.DoubleSide,
//   opacity: 0.9,
//   transparent: true
// })
// let vehicleRouting_material_motor_sub = new THREE.MeshBasicMaterial({
//   color: 0x8552a1,
//   side: THREE.DoubleSide,
//   opacity: 0.8,
//   transparent: true
// })
let planning_useMainReferenceLine = true; //主副参考线切换的标识
let useMotorRefId = 0; //主副参考线切换的标识 机动车模式下
/***
 * 主车导航；
 */
export const loadVehicleRouting = (
  vehicleData,
  threejs_global,
  vehicleParams,
) => {
  if (vehicleData.planning) {
    planning_useMainReferenceLine = vehicleData.planning?.useMainReferenceLine;
    useMotorRefId = vehicleData.planning?.useMotorRefId;
  }
  if (!visible_group) {
    if (group_vehicleRouting) {
      group_vehicleRouting.visible = false;
    }
    return;
  }

  if (vehicleData && vehicleData.routing) {
    //存在routing
    if (group_vehicleRouting) {
      disposeO3D(group_vehicleRouting);
    }
    {
      let group_routing_order = getGroupOrderZ('pnc_routing');
      group_vehicleRouting = new THREE.Group();
      group_vehicleRouting.timeEx = 40;
      group_vehicleRouting.position.set(
        vehicleData.origin.x,
        vehicleData.origin.y,
        group_routing_order.z,
      );
      threejs_global.scene.add(group_vehicleRouting);
      if (vehicleData.routing.routerEdition == 2) {
        render_routing_MOTOR(vehicleData, threejs_global, vehicleParams);
      } else {
        render_routing_NON_MOTOR(vehicleData, threejs_global, vehicleParams);
      }
    }
    render_stop(vehicleData, threejs_global, vehicleParams);
  } else {
    //不存在routing 使用缓存
    if (group_vehicleRouting) {
      group_vehicleRouting.timeEx--;
      if (group_vehicleRouting.timeEx <= 0) {
        disposeO3D(group_vehicleRouting);
        group_vehicleRouting = null;
      }
    }
  }
};

/**
 * 根据配置，设置停靠点显示隐藏
 * @param {*} e
 */
export function visible_routing(e) {
  if (routing_stop.parking_spot) {
    routing_stop.parking_spot.visible = e.includes('vehicledata_routing_stop');
  }
  if (routing_stop.mainStop) {
    routing_stop.mainStop.visible = e.includes('vehicledata_routing_stop');
  }
  visible_group = e.includes('/routing/routing_result');
  if (group_vehicleRouting) {
    group_vehicleRouting.visible = visible_group;
  }
}

export function clear_routing_group() {
  if (group_vehicleRouting) {
    disposeO3D(group_vehicleRouting);
  }
  if (routing_stop) {
    //清理停靠点
    disposeO3D(routing_stop?.mainStop);
    disposeO3D(routing_stop?.parking_spot);
    routing_stop.mainStop = null;
    routing_stop.id = null;
    routing_stop.parking_spot = null;
  }
}
function createChevronGeometry() {
  const shape = new THREE.Shape();
  shape.moveTo(0.32, 0);
  shape.lineTo(-0.22, 0.56);
  shape.lineTo(-0.42, 0.56);
  shape.lineTo(0.02, 0);
  shape.lineTo(-0.42, -0.56);
  shape.lineTo(-0.22, -0.56);
  shape.closePath();
  return new THREE.ShapeGeometry(shape);
}

function sampleAlongPolyline(points, spacing, startOffset = 0) {
  const out = [];
  if (!points?.length) return out;
  let remain = Math.max(0, startOffset);
  for (let i = 1; i < points.length; i++) {
    let x0 = points[i - 1].x;
    let y0 = points[i - 1].y;
    const x1 = points[i].x;
    const y1 = points[i].y;
    const dx = x1 - x0;
    const dy = y1 - y0;
    let len = Math.hypot(dx, dy);
    if (len < 1e-6) continue;
    const ux = dx / len;
    const uy = dy / len;
    const angle = Math.atan2(uy, ux);
    while (len >= remain) {
      x0 += ux * remain;
      y0 += uy * remain;
      out.push({ x: x0, y: y0, angle });
      len -= remain;
      remain = spacing;
    }
    remain -= len;
  }
  return out;
}

function offsetPolyline(points, offset) {
  if (!offset || !points?.length) return points;
  const out = [];
  for (let i = 0; i < points.length; i++) {
    const prev = points[Math.max(0, i - 1)];
    const next = points[Math.min(points.length - 1, i + 1)];
    const dx = next.x - prev.x;
    const dy = next.y - prev.y;
    const len = Math.hypot(dx, dy);
    if (len < 1e-6) {
      out.push({ x: points[i].x, y: points[i].y });
      continue;
    }
    out.push({
      x: points[i].x + (-dy / len) * offset,
      y: points[i].y + (dx / len) * offset,
    });
  }
  return out;
}

function addRoutingInstances(samples, { geometry, material, scale, z, renderOrder }) {
  const mesh = new THREE.InstancedMesh(geometry, material, samples.length);
  for (let i = 0; i < samples.length; i++) {
    routingArrowDummy.position.set(samples[i].x, samples[i].y, z);
    routingArrowDummy.rotation.set(0, 0, samples[i].angle);
    routingArrowDummy.scale.set(scale[0], scale[1], 1);
    routingArrowDummy.updateMatrix();
    mesh.setMatrixAt(i, routingArrowDummy.matrix);
  }
  mesh.instanceMatrix.needsUpdate = true;
  // 不参与场景拾取，避免挡住选点/点地图/点小车。
  mesh.raycast = function () {};
  mesh.renderOrder = renderOrder;
  mesh.matrixAutoUpdate = false;
  mesh.frustumCulled = false;
  group_vehicleRouting.add(mesh);
}

function addRoutingRibbon(points, { isMainStyle, isOnTop }) {
  if (!points?.length || !group_vehicleRouting) return;
  const drawPoints = isMainStyle
    ? points
    : offsetPolyline(points, ROUTING_SUB_LATERAL_OFFSET);
  const scale = isMainStyle
    ? ROUTING_ARROW_SCALE_MAIN
    : ROUTING_ARROW_SCALE_SUB;
  const samples = sampleAlongPolyline(
    drawPoints,
    ROUTING_ARROW_SPACING,
    isMainStyle ? ROUTING_ARROW_START_MAIN : ROUTING_ARROW_START_SUB,
  );
  if (!samples.length) return;
  const z = isOnTop ? 0.002 : 0.001;
  addRoutingInstances(samples, {
    geometry: createChevronGeometry(),
    material: isMainStyle
      ? vehicleRouting_material
      : vehicleRouting_material_sub,
    scale: [scale, scale],
    z,
    renderOrder: isMainStyle ? 201 : 200,
  });
}

function render_routing_NON_MOTOR(vehicleData, threejs_global, vehicleParams) {
  if (vehicleData.routing.routingLineList.length > 0) {
    const isMainStyle = !!planning_useMainReferenceLine;
    addRoutingRibbon(vehicleData.routing.routingLineList, {
      isMainStyle,
      isOnTop: isMainStyle,
    });
  }
  if (vehicleData.routing.subRoutingLineList?.length > 0) {
    for (let i = 0; i < vehicleData.routing.subRoutingLineList?.length; i++) {
      const isMainStyle = !planning_useMainReferenceLine;
      addRoutingRibbon(
        vehicleData.routing.subRoutingLineList[i].routingLineList,
        {
          isMainStyle,
          isOnTop: isMainStyle,
        },
      );
    }
  }
}
function render_routing_MOTOR(vehicleData, threejs_global, vehicleParams) {
  //机动车模式下：routing
  if (vehicleData.routing.motorRoutingLineList?.length > 0) {
    for (let i = 0; i < vehicleData.routing.motorRoutingLineList?.length; i++) {
      let points = vehicleData.routing.motorRoutingLineList[i].routingLineList;
      let elementId = vehicleData.routing.motorRoutingLineList[i].id;
      const isMain = useMotorRefId == elementId;
      addRoutingRibbon(points, { isMainStyle: isMain, isOnTop: isMain });
    }
  }
}

function render_stop(vehicleData, threejs_global, vehicleParams) {
  {
    if (routing_stop.id != vehicleData.routing?.spot?.id) {
      //id 更新停靠点的渲染
      routing_stop.id = vehicleData.routing?.spot?.id;
      if (routing_stop.mainStop) {
        disposeO3D(routing_stop?.mainStop);
      }
      {
        //主停靠点
        if (vehicleData.routing?.spot?.stopSpot) {
          let item = vehicleData.routing?.spot?.stopSpot;
          if (item.mapX && item.mapY) {
            routing_stop.mainStop = create_routing_stop(
              item?.mapX,
              item.mapY,
              item.angle,
              1,
              vehicleParams,
            );
            threejs_global.scene.add(routing_stop.mainStop);
          }
        }
      }
      if (routing_stop.parking_spot) {
        disposeO3D(routing_stop?.parking_spot);
      }
      {
        //副停靠点
        if (vehicleData.routing?.spot?.parkingSpotList?.length > 0) {
          routing_stop.parking_spot = [];
          let group = new THREE.Group();
          for (
            let i = 0;
            i < vehicleData.routing?.spot?.parkingSpotList?.length;
            i++
          ) {
            let item = vehicleData.routing?.spot?.parkingSpotList[i];
            if (item.mapX && item.mapY) {
              let park_stop = create_routing_stop(
                item.mapX,
                item.mapY,
                item.angle,
                2,
                vehicleParams,
              );
              group.add(park_stop);
            }
          }
          threejs_global.scene.add(group);
          routing_stop.parking_spot = group;
        }
      }
    } else {
      //
    }
  }
}
